export default __webpack_public_path__ + "static/media/image_processing.5c28ab79.jpg";